import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ThemeService } from '../services/theme';
import { themeAsset } from '../services/theme-asset';
import { TimeAgo } from '../time-ago/time-ago';
import { V3InfoButton } from '../v3-info-button/v3-info-button';

@Component({
  selector: 'app-v3-analysis-header',
  templateUrl: './v3-analysis-header.html',
  styleUrl: './v3-analysis-header.scss',
  standalone: true,
  imports: [TimeAgo, V3InfoButton],
})
export class V3AnalysisHeader {
  @Input() stockLogo!: string | null;
  @Input() title = '';
  @Input() updatedAt!: Date | null;
  // False on the tab's own info page — see v3-info-page/CLAUDE.md.
  @Input() showInfoButton = true;
  @Output() backClicked = new EventEmitter<void>();
  @Output() infoClicked = new EventEmitter<void>();

  private readonly themeService = inject(ThemeService);

  readonly backIconSrc = themeAsset(this.themeService, 'back');
}
